/**
 * Prevent duplicate userform submissions.
 *
 * SilverStripe userforms submit as a full-page POST that takes a few seconds.
 * With no visible feedback, users click "Submit" again, producing a second
 * POST — and userforms sends one email per POST, so enquiries arrived as
 * duplicate emails. This disables the form's submit control(s) once a genuine
 * submission is under way so a second click can't fire.
 *
 * We hook userforms' own `userform.form.submit` jQuery event rather than the
 * raw DOM `submit`. userforms always runs jQuery-validate, which cancels the
 * native submit when the form is invalid; a raw `submit` listener would then
 * disable the button on a validation failure and — since no navigation
 * happens — leave the form stuck on "Sending…" forever. `userform.form.submit`
 * fires only after validation passes and the real POST is being sent.
 *
 * Notes:
 * - jQuery is always present: userforms depends on it.
 * - Disabling is deferred a tick so the submit button's name/value
 *   (`action_process`) are serialised into the POST first (a disabled control
 *   is omitted).
 * - We re-enable on pageshow (bfcache back/forward) so a returning visitor
 *   isn't left with a permanently disabled form.
 */
(function () {
    'use strict';

    if (!window.jQuery) return;
    var $ = window.jQuery;
    var SENDING_LABEL = 'Sending…';

    // Only the form's action buttons — not the multi-step next/prev nav, which
    // drives step changes rather than submit.
    function submitControls(form) {
        return form.querySelectorAll(
            '.Actions input[type="submit"], .Actions button[type="submit"], .Actions button:not([type])'
        );
    }

    function guard(form) {
        if (form.dataset.submitting === 'true') return;
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');

        submitControls(form).forEach(function (control) {
            if (control.tagName === 'BUTTON') {
                control.dataset.originalLabel = control.innerHTML;
                control.innerHTML = SENDING_LABEL;
            } else {
                control.dataset.originalLabel = control.value;
                control.value = SENDING_LABEL;
            }
            // Defer disabling to the next tick so the value is serialised into
            // the outgoing POST first (a disabled control is omitted).
            window.setTimeout(function () {
                control.disabled = true;
                control.setAttribute('aria-disabled', 'true');
            }, 0);
        });
    }

    function release(form) {
        delete form.dataset.submitting;
        form.removeAttribute('aria-busy');
        submitControls(form).forEach(function (control) {
            control.disabled = false;
            control.removeAttribute('aria-disabled');
            if (typeof control.dataset.originalLabel === 'string') {
                if (control.tagName === 'BUTTON') {
                    control.innerHTML = control.dataset.originalLabel;
                } else {
                    control.value = control.dataset.originalLabel;
                }
                delete control.dataset.originalLabel;
            }
        });
    }

    // userforms fires this only after jQuery-validate passes and the real POST
    // is being sent — never on a validation failure.
    $(document).on('userform.form.submit', 'form.userform', function () {
        guard(this);
    });

    // Restore forms served from the bfcache (back button), otherwise a
    // returning visitor finds the form stuck on "Sending…".
    window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        document.querySelectorAll('form.userform[data-submitting]').forEach(release);
    });
})();
